import { LogOut, Menu } from 'lucide-react';
import { useAuth } from '@/components/auth/AuthProvider';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ENV_LABEL } from '@/lib/supabase';

export function TopBar({ onOpenNav }: { onOpenNav?: () => void }) {
  const { user, signOut } = useAuth();
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-background/80 px-5 backdrop-blur">
      <div className="flex items-center gap-3">
        {onOpenNav && (
          <Button
            variant="ghost"
            size="sm"
            className="lg:hidden"
            aria-label="Open navigation"
            onClick={onOpenNav}
          >
            <Menu className="h-4 w-4" />
          </Button>
        )}
        <Badge variant="info">{ENV_LABEL}</Badge>
        <span className="text-sm text-muted-foreground">
          Sports API Data · Supabase
        </span>
      </div>
      <div className="flex items-center gap-3">
        <div className="hidden text-xs text-muted-foreground md:block">{user?.email}</div>
        <Button variant="ghost" size="sm" onClick={() => void signOut()}>
          <LogOut className="h-4 w-4" /> Sign out
        </Button>
      </div>
    </header>
  );
}
